import { useGetCountriesQuery } from '../components/admin-portal/TravelDistances/queries';
import { Option } from '../components/shared/ControlledFields/ControlledSelect';

import { useGetOptions } from './useGetOptions';

export const useGetCountryCodeOptions = (): Option[] | [] => {
  const { data = [], isError } = useGetCountriesQuery();

  return useGetOptions(data, isError, 'code', 'name');
};
